import React, { Component } from 'react';
import { Switch, message } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import axios from 'axios';
import Configuration from '../../Configuration';

class GeneralConfiguration extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, current: {}};
    this.validateToken = this.validateToken.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getConfiguration();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin"))
      this.setState({redirect: true});
  }

  getConfiguration() {
    axios.get(`${Configuration.apiServer}/api/v1/configuration`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data === null)
        return message.warning('Petición inválida')

      this.setState({current: resp.data});
    });
  }

  handleUpdate(kind, value) {
    let sendData = {};
    sendData[kind] = value;

    axios.put(`${Configuration.apiServer}/api/v1/configuration/${kind}`, sendData, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      this.getConfiguration();
    });
  }

  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render component
    return (
      <div>
        <PublicMenu />

        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Configuración general</h3>
          </div>

          <br/>
          
          <table className="table">
            <tbody>
              <tr>
                <td>Enviar notificaciones de visitas a la App móvil</td>
                <td><Switch key={`mobileNotifications:${this.state.current.id}`} defaultChecked={this.state.current.mobile_notifications} onChange={(value) => { this.handleUpdate('mobile_notifications', value) }} /></td>
              </tr>
              <tr>
                <td>Enviar resumen de visita por Email a los visitantes</td>
                <td><Switch key={`visitorsEmail:${this.state.current.id}`} defaultChecked={this.state.current.send_visitor_email} onChange={(value) => { this.handleUpdate('send_visitor_email', value) }} /></td>
              </tr>
              <tr>
                <td>Registro de visitas para transportistas</td>
                <td><Switch key={`carrierVisit:${this.state.current.id}`} defaultChecked={this.state.current.carrier_visits} onChange={(value) => { this.handleUpdate('carrier_visits', value) }} /></td>
              </tr>
              <tr>
                <td>Autorización de visitas por nivel de acceso</td>
                <td><Switch key={`authorizationLevel:${this.state.current.id}`} defaultChecked={this.state.current.authorization_levels} onChange={(value) => { this.handleUpdate('authorization_levels', value) }} /></td>
              </tr>
              <tr>
                <td>Autorización de visitas no registradas o casuales</td>
                <td><Switch key={`casualVisit:${this.state.current.id}`} defaultChecked={this.state.current.casual_visits} onChange={(value) => { this.handleUpdate('casual_visits', value) }} /></td>
              </tr>
              <tr>
                <td>Registro de herramientas o aditamentos para visitas</td>
                <td><Switch key={`visitTools:${this.state.current.id}`} defaultChecked={this.state.current.visit_tools} onChange={(value) => { this.handleUpdate('visit_tools', value) }} /></td>
              </tr>
              <tr>
                <td>Registro previo de auto para visitas</td>
                <td><Switch key={`visitorCar:${this.state.current.id}`} defaultChecked={this.state.current.visitor_car} onChange={(value) => { this.handleUpdate('visitor_car', value) }} /></td>
              </tr>
              <tr>
                <td>Enviar notificaciones por SMS</td>
                <td><Switch key={`sendSms:${this.state.current.id}`} defaultChecked={this.state.current.send_sms} onChange={(value) => { this.handleUpdate('send_sms', value) }} /></td>
              </tr>
              <tr>
                <td>Registro de tags para autos</td>
                <td><Switch key={`tagsAdministration:${this.state.current.id}`} defaultChecked={this.state.current.tags_administration} onChange={(value) => { this.handleUpdate('tags_administration', value) }} /></td>
              </tr>
              <tr>
                <td>Registro de tarjetas de acceso</td>
                <td><Switch key={`accessCardsAdminsitration:${this.state.current.id}`} defaultChecked={this.state.current.access_cards_administration} onChange={(value) => { this.handleUpdate('access_cards_administration', value) }} /></td>
              </tr>
              <tr>
                <td>Ingreso de visitantes por código QR</td>
                <td><Switch key={`visitQr:${this.state.current.id}`} defaultChecked={this.state.current.visit_qr} onChange={(value) => { this.handleUpdate('visit_qr', value) }} /></td>
              </tr>
              <tr>
                <td>Dias de historial que pueden ver en caseta</td>
                <td><input type="number" className="form-control" key={`timelineDays:${this.state.current.id}`} defaultValue={this.state.current.timeline_days} onChange={(value) => { if(value.target.value) { this.handleUpdate('timeline_days', value.target.value) } }} /></td>
              </tr>
              <tr>
                <td>Tiempo de vigencia de una visita (Minutos)</td>
                <td><input type="number" className="form-control" key={`expirationTime:${this.state.current.id}`} defaultValue={this.state.current.expiration_time} onChange={(value) => { if(value.target.value) { this.handleUpdate('expiration_time', value.target.value) } }} /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default GeneralConfiguration;



// WEBPACK FOOTER //
// ./src/pages/admin/GeneralConfig.js